import { createApp, h } from "vue";
import Bugsnag from "@bugsnag/js";
import BugsnagVue from "@bugsnag/plugin-vue";
import ElementPlus from "element-plus";
import baseBugsnag from "@nextories/vue-core-components/src/utils/modules/bugsnag";
import '@nextories/vue-tasks/src/assets/scss/external/element-variables.scss';
import nxtVueTasks from "@nextories/vue-tasks/src/main";
import AppApi from "./utils/AppApi";
import MoverApi from "@nextories/vue-tasks/src/utils/MoverApi";
import App from "./App.vue";
import router from "./router";
import axios from "@nextories/vue-tasks/src/utils/modules/axios";
import { i18nPlugin } from "./plugins/i18n";
import piniaPlugin from "./plugins/pinia";

const app = createApp({
  data() {
    return {
      prefixCSS: import.meta.env.nxt.prefixCSS ? `${import.meta.env.nxt.prefixCSS}-` : "",
    };
  },
  render() {
    return h(App);
  },
});

app.use(i18nPlugin);
app.use(piniaPlugin);
baseBugsnag.config(import.meta.env.nxt);

if (nxtVueTasks && nxtVueTasks.install) {
  app.use(nxtVueTasks.install);
}

app.use(router);

app.config.globalProperties.$API = axios(router);
window.connector = new AppApi(app.config.globalProperties.$API);

// Init mover api
app.config.globalProperties.$MOVER_API = axios(
  router,
  undefined,
  import.meta.env.VITE_APP_MOVER_API,
  import.meta.env.VITE_APP_MOVER_API_SECURITY_KEY,
);
window.moverAppConnector = new MoverApi(app.config.globalProperties.$MOVER_API, true);

app.mount("#app");
